export default __webpack_public_path__ + "static/Festl_Tour_Impressionen_3-48e514e99e9b98240902e35822a6b24a.jpg";